@if (actions$ | async) {}
@if (uploadQueue$ | async) {}

<nz-page-header nzTitle="Создание обмена" nzBackIcon (nzBack)="goBack()">
</nz-page-header>

<div class="container">
  <nz-card nz-col nzFlex="0 0 40%" class="form-container">
    <nz-form-item>
      <nz-form-label [nzSpan]="4"> <b>Тема</b> </nz-form-label>
      <nz-form-control [nzSpan]="20">
        <input
          nz-input
          type="text"
          placeholder="Введите тему"
          maxlength="200"
          [(ngModel)]="sharingFilesTheme"
        /> </nz-form-control
    ></nz-form-item>

    <nz-form-item>
      <nz-form-label
        nzTooltipTitle="Максимальный размер файла - 1ГБ"
        [nzSpan]="4"
        [nzTooltipIcon]="addFilesTooltipIcon"
      >
        <b>Файлы</b>
      </nz-form-label>
      <nz-form-control [nzSpan]="20">
        <nz-upload
          nzListType="text"
          nzShowProgress
          nzShowUploadList="{showRemoveIcon: false}"
          [(nzFileList)]="fileList"
          [nzCustomRequest]="uploadFile"
          [nzMultiple]="true"
          (nzChange)="handleChangeFileList($event)"
        >
          <button nz-button>
            <span nz-icon nzType="upload"></span>
            Загрузить
          </button>
        </nz-upload>
      </nz-form-control>
    </nz-form-item>
  </nz-card>

  @if (uploadedFiles.length > 0) {
    <div class="files-column">
      <nz-card nzTitle="Загруженные файлы">
        <div class="files-grid">
          @for (file of uploadedFiles; track $index) {
            <div>
              <div class="file-name-row">
                <span class="file-name" [title]="file.name">{{
                  file.name
                }}</span>
                <span
                  nz-icon
                  nzType="delete"
                  nzTheme="outline"
                  class="action-icon delete-file-icon"
                  (click)="deleteFile(file)"
                >
                </span>
              </div>
              <textarea
                nz-input
                placeholder="Введите описание файла"
                class="file-description-input"
                rows="2"
                [(ngModel)]="file.description"
                [maxlength]="250"
              ></textarea>

              @if ($index !== uploadedFiles.length - 1) {
                <nz-divider></nz-divider>
              }
            </div>
          }
        </div>
      </nz-card>
      <div class="send-button">
        <button
          nz-button
          nzType="primary"
          nzShape="round"
          [disabled]="disableSendButton"
          (click)="sendFileSharing()"
        >
          Отправить
        </button>
      </div>
    </div>
  }
</div>
